import {
    AvatarCardHeader,
    GroupHeadlineTeaserStack,
    HeadlinePostInputButton,
    HeadlineTeaserAvatar,
    HeadlineTeaserBoxTypography,
    HeadlineTeaserStack,
} from "./HeadlineTeaserBox.styles";
import React from "react";
import { useUserProfile } from "../../../../Infrastructure/Persistence/UserProfileState";
import { AvatarOptions } from "../../UserAvatar/UserAvatar.types";
import userAvatarChecker from "../../../Shared/UserAvatarChecker";
import { usePostFormModalStore } from "../../../Pages/GroupDetailsPage/Stores/PostFormModalStore";
import {
    POST_SOURCE_TYPE,
    POST_FORM_CONTENT_INPUT,
} from "../../Post/PostForm/PostFormModal.types";
import { UserAvatarFactory } from "../../UserAvatar/UserAvatarFactory";
import { Box } from "@mui/system";
import { PhotoFilmIcon } from "../../Icon/PhotoFilmSolidIcon";
import { useGlobalConfigs } from "../../../../Infrastructure/Hooks/useGlobalConfigs";
import { useInView } from "../../../../Infrastructure/Hooks/useInView";

export const DEFAULT_CREATE_POST_PLACEHOLDER = "Was machst du gerade?";

export function HeadlineTeaserBoxWithPostFormButtons({
    onComponentOutOfSight,
    onComponentVisible,
}: {
    onComponentOutOfSight: () => void;
    onComponentVisible: () => void;
}) {
    const { ref, inView } = useInView();

    React.useEffect(() => {
        if (inView) {
            onComponentVisible();
        } else {
            onComponentOutOfSight();
        }
    }, [inView]);

    const { uuid, gender, avatar } = useUserProfile();
    const avatarOptions: AvatarOptions = {
        uuid: uuid,
        avatar: avatar,
        gender: gender,
        fallbackColor: !uuid ? "#596E38" : undefined,
        onError: () => userAvatarChecker(avatar, uuid),
        component: HeadlineTeaserAvatar,
    };
    const { setIsPostFormModalOpen } = usePostFormModalStore();
    const { getConfigs } = useGlobalConfigs();
    const showSortOptions = getConfigs()?.tippspielFeedSortingEnabled;
    const tippspielFeedCreatePostPlaceholder =
        getConfigs()?.tippspielFeedCreatePostPlaceholder ??
        DEFAULT_CREATE_POST_PLACEHOLDER;

    return (
        <>
            <GroupHeadlineTeaserStack
                ref={ref}
                onClick={() => {
                    setIsPostFormModalOpen(
                        true,
                        POST_FORM_CONTENT_INPUT.DEFAULT,
                        POST_SOURCE_TYPE.TEASER_INPUT,
                    );
                }}
                marginBottom={!showSortOptions ? "16px" : "0"}
            >
                <HeadlineTeaserStack>
                    <AvatarCardHeader
                        avatar={UserAvatarFactory(avatarOptions)}
                    />
                    <HeadlineTeaserBoxTypography>
                        {tippspielFeedCreatePostPlaceholder}
                    </HeadlineTeaserBoxTypography>
                </HeadlineTeaserStack>
                <Box
                    style={{
                        alignSelf: "center",
                    }}
                >
                    <HeadlinePostInputButton>
                        <PhotoFilmIcon
                            color={"var(--community-color-primary-text)"}
                        />
                    </HeadlinePostInputButton>
                </Box>
            </GroupHeadlineTeaserStack>
        </>
    );
}
